// extracted by mini-css-extract-plugin
module.exports = {"root":"InDeveloping_root__1b2yC"};